<template>
  <div class="mobile-menu-wrapper">
    <!-- 蒙层过渡，点击蒙层关闭菜单 -->
    <transition name="overlay-fade">
      <div
        v-if="visible"
        class="custom-overlay"
        @click="closeMenu"
      ></div>
    </transition>

    <!-- 抽屉面板过渡：根据 direction 从右侧或左侧滑入 -->
    <transition :name="direction === 'rtl' ? 'drawer-slide-rtl' : 'drawer-slide-ltr'">
      <div
        v-if="visible"
        class="custom-drawer"
        :class="direction"
        :style="panelStyle"
      >
        <div class="mobile-menu">
          <!-- 菜单头部（保留结构，后续可按需启用） -->
          <!-- <div class="menu-header">
            <div class="logo">
              <img src="@/assets/logo.png" alt="logo" class="logo-img" />
            </div>
            <button 
              type="button"
              class="close-btn"
              @click="closeMenu"
            >
              ×
            </button>
          </div> -->

          <!-- 菜单内容 -->
          <div class="menu-content">
            <nav class="mobile-nav">
              <router-link to="/" class="mobile-nav-item" @click="closeMenu">
                首页
              </router-link>
              <router-link to="/price" class="mobile-nav-item" @click="closeMenu">
                价格
              </router-link>
              <a v-if="isLogined" class="mobile-nav-item" @click="goToWorkbench">
                进入工作台
              </a>
              <router-link to="/login" class="mobile-nav-item" @click="closeMenu">
                {{ getLoginText() }}
              </router-link>
              <p class="mobile-nav-item no-border"> 400-8888-168</p>
            </nav>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'

// 组件对外接收的属性：保持与原有 el-drawer 一致的 API
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  userData: {
    type: Object,
    default: undefined
  },
  // 控制抽屉方向：rtl 从右侧滑入，ltr 从左侧滑入
  direction: {
    type: String,
    default: 'rtl'
  },
  // 抽屉宽度：支持字符串百分比或数字像素值
  size: {
    type: [String, Number],
    default: '100%'
  }
})

// 组件对外触发的事件
const emit = defineEmits(['update:modelValue', 'contact', 'logout'])

const router = useRouter()
const route = useRoute()

// 后台工作台地址（保留原有逻辑）
const workbenchUrl = ref(import.meta.env.VITE_GLOB_BACK_URL)
const externalUrl = ref('')
const isLogin = ref(false)

watch(
  () => props.modelValue,
  (newVal) => {
    // 同步 visible 显示, 并检查登录状态
    isLogin.value = !!localStorage.getItem('access_token');
    console.log('visible...', isLogin.value);
  },
  { immediate: true }
)


// 计算属性：实现 v-model 双向绑定
const visible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

// 抽屉面板的样式：根据 size 动态设置宽度
const panelStyle = computed(() => {
  const width = typeof props.size === 'number' ? `${props.size}px` : String(props.size)
  return {
    width
  }
})

// 登录状态（用于显示“进入工作台”与“登录/退出登录”文案）
const isLogined = localStorage.getItem('access_token')

const getLoginText = () => {
  return localStorage.getItem('access_token') ? '退出登录' : '登录'
}

// 关闭菜单
const closeMenu = () => {
  visible.value = false
}

// 联系客服
const handleContact = () => {
  emit('contact')
  closeMenu()
}

// 退出登录
const handleLogout = () => {
  emit('logout')
  closeMenu()
}

// 跳转到注册页面
const goToRegister = () => {
  router.push({
    path: '/login',
    query: {
      tab: 'register',
      redirect: route.fullPath
    }
  })
  closeMenu()
}

// 跳转到工作台
const goToWorkbench = () => {
  let clientId = import.meta.env.VITE_GLOB_APP_CLIENT_ID || ''
  if (window.innerWidth < 768) {
    clientId = import.meta.env.VITE_GLOB_APP_CLIENT_ID_MOBILE || ''
  }
  const accessToken = localStorage.getItem('access_token')
  const externalUrl = `${location.origin}/back/preview/index.html#/redirect?accessToken=${accessToken}&clientId=${clientId}`
  window.location.href = externalUrl
  closeMenu()
}
</script>

<style scoped>
/* 外层容器：用于承载蒙层与抽屉面板 */
.mobile-menu-wrapper {
  position: relative;
}

/* 自定义蒙层：与原 el-drawer 的透明蒙层保持一致 */
.custom-overlay {
  position: fixed;
  top: 70px; /* 避开固定头部 */
  left: 0;
  right: 0;
  bottom: 0;
  background-color: transparent; /* 与原项目保持透明蒙层 */
  z-index: 1999;
}

/* 蒙层淡入淡出过渡 */
.overlay-fade-enter-active,
.overlay-fade-leave-active {
  transition: opacity 0.2s ease;
}
.overlay-fade-enter-from,
.overlay-fade-leave-to {
  opacity: 0;
}

/* 自定义抽屉面板：替代 el-drawer */
.custom-drawer {
  position: fixed;
  top: 70px; /* 避开固定头部 */
  height: calc(100vh - 70px);
  background-color: #fff;
  z-index: 2000;
  overflow: hidden;
  touch-action: none; /* 防止移动端背景滚动 */
  will-change: transform;
}
.custom-drawer.rtl {
  right: 0;
}
.custom-drawer.ltr {
  left: 0;
}

/* 右侧滑入过渡（rtl） */
.drawer-slide-rtl-enter-active,
.drawer-slide-rtl-leave-active {
  transition: transform 0.3s ease;
}
.drawer-slide-rtl-enter-from,
.drawer-slide-rtl-leave-to {
  transform: translateX(100%);
}
.drawer-slide-rtl-enter-to,
.drawer-slide-rtl-leave-from {
  transform: translateX(0);
}

/* 左侧滑入过渡（ltr） */
.drawer-slide-ltr-enter-active,
.drawer-slide-ltr-leave-active {
  transition: transform 0.3s ease;
}
.drawer-slide-ltr-enter-from,
.drawer-slide-ltr-leave-to {
  transform: translateX(-100%);
}
.drawer-slide-ltr-enter-to,
.drawer-slide-ltr-leave-from {
  transform: translateX(0);
}

.mobile-menu {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
}

.menu-header .logo {
  display: flex;
  align-items: center;
}

.logo-img {
  width: 130px;
  height: 33px;
}

.close-btn {
  font-size: 24px;
  color: #666;
}

.menu-content {
  flex: 1;
  padding: 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 200px;
}

.mobile-nav {
  display: flex;
  flex-direction: column;
  /* gap: 20px; */
  /* margin-bottom: 40px; */
  padding: 0 12px;

}

.mobile-nav-item {
  display: flex;
  justify-content: center;
  padding: 15px 0;
  font-size: 18px;
  font-weight: 500;
  color: #333;
  text-decoration: none;
  border-bottom: 1px solid #f0f0f0;
  transition: color 0.3s ease;

  &.no-border {
    border-bottom: none;
  }
}

/* .mobile-nav-item:hover, */
.mobile-nav-item.router-link-active {
  color: #7B67FF;
}

.mobile-actions {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.mobile-contact-btn {
  width: 100%;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  background: linear-gradient(270deg, #7148FF 0%, #6B66FE 100%);
  border: none;
}

.auth-buttons {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.mobile-login-btn {
  display: block;
  padding: 15px 0;
  text-align: center;
  font-size: 16px;
  color: #7B67FF;
  text-decoration: none;
  border: 1px solid #7B67FF;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.mobile-login-btn:hover {
  background: #7B67FF;
  color: #fff;
}

.mobile-register-btn {
  width: 100%;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  background: linear-gradient(270deg, #7148FF 0%, #6B66FE 100%);
  border: none;
}

.user-info {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.mobile-workbench-btn {
  display: block;
  padding: 15px 0;
  text-align: center;
  font-size: 16px;
  color: #7B67FF;
  text-decoration: none;
  border: 1px solid #7B67FF;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.mobile-workbench-btn:hover {
  background: #7B67FF;
  color: #fff;
}

.mobile-logout-btn {
  width: 100%;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  background: linear-gradient(270deg, #7148FF 0%, #6B66FE 100%);
  border: none;
}

/* 删除 Element Plus 抽屉相关样式，改由自定义抽屉控制 */
</style>
